import { apiClient } from "@/lib/api/client";
import type {
  PlatformRoleCreateBody,
  PlatformRoleDto,
  PlatformRoleListResponseDto,
  PlatformRoleUpdateBody,
} from "@/lib/api/types/enterprise";

export async function listPlatformRoles(): Promise<PlatformRoleListResponseDto> {
  const { data } = await apiClient.get<PlatformRoleListResponseDto>("/platform-roles", { __skipTenantHeader: true });
  return data;
}

export async function createPlatformRole(body: PlatformRoleCreateBody): Promise<PlatformRoleDto> {
  const { data } = await apiClient.post<PlatformRoleDto>("/platform-roles", body, { __skipTenantHeader: true });
  return data;
}

export async function updatePlatformRole(roleId: string, body: PlatformRoleUpdateBody): Promise<PlatformRoleDto> {
  const { data } = await apiClient.put<PlatformRoleDto>(`/platform-roles/${roleId}`, body, { __skipTenantHeader: true });
  return data;
}

export async function deletePlatformRole(roleId: string): Promise<void> {
  await apiClient.delete(`/platform-roles/${roleId}`, { __skipTenantHeader: true });
}
